__turbopack_context__.v({
  "bannerLayer": "SpotlightTerrace-module-scss-module__ovsk6a__bannerLayer",
  "blocksBackgroundColor": "SpotlightTerrace-module-scss-module__ovsk6a__blocksBackgroundColor",
  "blocksFontColor": "SpotlightTerrace-module-scss-module__ovsk6a__blocksFontColor",
  "cascadeUp": "SpotlightTerrace-module-scss-module__ovsk6a__cascadeUp",
  "content": "SpotlightTerrace-module-scss-module__ovsk6a__content",
  "contentVisible": "SpotlightTerrace-module-scss-module__ovsk6a__contentVisible",
  "curationContainer": "SpotlightTerrace-module-scss-module__ovsk6a__curationContainer",
  "expandButton": "SpotlightTerrace-module-scss-module__ovsk6a__expandButton",
  "expandButtonContainer": "SpotlightTerrace-module-scss-module__ovsk6a__expandButtonContainer",
  "imageContainer": "SpotlightTerrace-module-scss-module__ovsk6a__imageContainer",
  "message": "SpotlightTerrace-module-scss-module__ovsk6a__message",
  "reorderBanner": "SpotlightTerrace-module-scss-module__ovsk6a__reorderBanner",
  "rotateFromCenter": "SpotlightTerrace-module-scss-module__ovsk6a__rotateFromCenter",
  "rotateToCenter": "SpotlightTerrace-module-scss-module__ovsk6a__rotateToCenter",
  "secondaryNavBackgroundColor": "SpotlightTerrace-module-scss-module__ovsk6a__secondaryNavBackgroundColor",
  "slideDownFromCenter": "SpotlightTerrace-module-scss-module__ovsk6a__slideDownFromCenter",
  "themeBackgroundColor": "SpotlightTerrace-module-scss-module__ovsk6a__themeBackgroundColor",
  "themeFontColor": "SpotlightTerrace-module-scss-module__ovsk6a__themeFontColor",
  "tile": "SpotlightTerrace-module-scss-module__ovsk6a__tile",
  "tileButton": "SpotlightTerrace-module-scss-module__ovsk6a__tileButton",
  "tileDragWrapper": "SpotlightTerrace-module-scss-module__ovsk6a__tileDragWrapper",
  "tileDragWrapperSource": "SpotlightTerrace-module-scss-module__ovsk6a__tileDragWrapperSource",
  "tileExpanded": "SpotlightTerrace-module-scss-module__ovsk6a__tileExpanded",
  "tileReorder": "SpotlightTerrace-module-scss-module__ovsk6a__tileReorder",
  "tileTitle": "SpotlightTerrace-module-scss-module__ovsk6a__tileTitle",
  "tilesContainer": "SpotlightTerrace-module-scss-module__ovsk6a__tilesContainer",
  "tilesContainerDragging": "SpotlightTerrace-module-scss-module__ovsk6a__tilesContainerDragging",
  "tilesContainerExpanded": "SpotlightTerrace-module-scss-module__ovsk6a__tilesContainerExpanded",
  "tilesContainerReorder": "SpotlightTerrace-module-scss-module__ovsk6a__tilesContainerReorder",
  "transitioningIn": "SpotlightTerrace-module-scss-module__ovsk6a__transitioningIn",
  "transitioningOut": "SpotlightTerrace-module-scss-module__ovsk6a__transitioningOut",
});
